import { TagIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import CommonTagSelection from "app/containers/Features/components/CommonTagSelection";
import { selectTagList } from "app/redux/selector";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  selectedTags: string[];
  onTagsChange: (val: string[]) => void;
  onOpen: () => void;
  onClose: () => void;
}
const TagsButton: React.FC<Props> = ({
  onTagsChange,
  selectedTags,
  onClose,
  onOpen,
}) => {
  const handleSelectionChange = (updatedSelectedItems) => {
    if (onTagsChange) {
      onTagsChange(updatedSelectedItems);
    }
  };
  return (
    <>
      <CommonTagSelection
        selectedTags={selectedTags}
        onTagsChange={(tagIds) => {
          handleSelectionChange(tagIds);
        }}
        trigger={
          <button className="flex items-center justify-center w-[28px] h-[28px] px-[6px] rounded-[4px] border border-[#E9ECF2] text-xs leading-[18px] font-medium text-secondary hover:bg-[#ECEEF2]  hover:border-[#E9ECF2] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] min-w-max  ">
            <CustomTooltip text="Set tags" position="bottom">
              <div className="flex items-center gap-1">
                <TagIcon />
                {selectedTags?.length > 0 && (
                  <span className="text-sm text-gray-700 bg-gray-200 px-1 py-1rounded">
                    {selectedTags?.length} tag
                  </span>
                )}
              </div>
            </CustomTooltip>
          </button>
        }
        isHeader="Tags"
        onOpen={onOpen}
        onClose={onClose}
      />
    </>
  );
};

export default TagsButton;
